<template>
    <div class="gs-checkout-rule-editor">
        <section class="gs-checkout-default-card">
            <div class="gs-checkout-default-card__copy">
                <small>Password collection</small>
                <h4>Choose when buyers create login credentials during checkout.</h4>
                <p>Use this only when the purchase needs account access immediately after payment.</p>
            </div>
        </section>

        <section class="gs-checkout-price-rules">
            <article
                v-for="(pricePoint, index) in localModel.password_options"
                :key="pricePoint.id || index"
                class="gs-checkout-price-rule"
            >
                <header class="gs-checkout-price-rule__head">
                    <div>
                        <strong>{{ localModelPricePointName(pricePoint.id) }}</strong>
                        <span>{{ passwordSummary(pricePoint) }}</span>
                    </div>
                    <div class="gs-checkout-price-rule__actions">
                        <label>
                            <span>{{ $t('frontend_ask_user_name') }}</span>
                            <gd-toggle :aria-label="$t('frontend_ask_user_name')" v-model="localModel.password_options[index].ask_username"
                                :value="localModel.password_options[index].ask_username" />
                        </label>
                        <label>
                            <span>{{ $t('frontend_ask_for_pass') }}</span>
                            <gd-toggle :aria-label="$t('frontend_ask_for_pass')" v-model="localModel.password_options[index].ask_for_password"
                                :value="localModel.password_options[index].ask_for_password" />
                        </label>
                    </div>
                </header>
            </article>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localModel: this.model
        }
    },
    watch: {
        localModel: {
            handler: function (val) {
                this.$emit('update-model', val);
                this.$emit('updateModel', val);
            },
            deep: true
        }
    },
    methods: {
        passwordSummary(pricePoint) {
            if (pricePoint.ask_username && pricePoint.ask_for_password) return 'Collect username and password';
            if (pricePoint.ask_username) return 'Collect username only';
            if (pricePoint.ask_for_password) return 'Collect password only';
            return 'No password collection';
        },
        localModelPricePointName(pricePointId) {
            const pp = this.localModel.pricing_points.find((obj) => {
                return obj.id == pricePointId;
            });

            if (pp) {
                return pp.name;
            }
            return 'Price point';
        },
    }
}
</script>
